import React, { useState } from 'react';

import { Dialog, DialogProps, DialogTitle } from '@material-ui/core';

type Props = DialogProps & {
  title: React.ReactNode;
};

const AccessibleDialog: React.FC<Props> = ({ children, title, ...dialogProps }) => {
  const [titleId] = useState(() => `accessible-dialog-title-${Math.random().toString(36).slice(2)}`);

  return (
    <Dialog
      {...dialogProps}
      aria-labelledby={titleId}
      aria-modal
      disableEnforceFocus={false}
      PaperProps={{
        ...dialogProps.PaperProps,
        'aria-labelledby': titleId,
        'aria-modal': true,
      }}
    >
      <DialogTitle id={titleId}>{title}</DialogTitle>
      {children}
    </Dialog>
  );
};

export default AccessibleDialog;
